<template>
  <UDrawer
    v-model:open="showHint"
    :inset="true"
    :handle="false"
    :dismissible="false"
    :ui="{
      overlay: 'bg-black/40',
      content: 'lg:max-w-240 lg:mx-auto rounded-none',
      container: '',
      title: 'lg:text-xl text-lg',
    }"
  >
    <template #title>
      <div class="flex items-center gap-2">
        <UIcon name="mdi-cookie-outline" />
        <h3>
          {{ t('dialog.cookie.desc') }}
        </h3>
      </div>
    </template>

    <template #body>
      <p class="text-sm lg:text-base text-default">
        {{ t('dialog.cookie.content') }}
        <ULink
          :to="'https://www.cookiesandyou.com'"
          target="_blank"
          class="text-primary underline underline-offset-2 hover:opacity-80"
        >
          {{ t('dialog.cookie.whatAreCookies') }}
        </ULink>
      </p>
    </template>

    <template #footer>
      <UTheme
        :ui="{
          button: {
            base: 'lg:w-auto w-full',
          },
        }"
      >
        <div class="flex justify-between items-center flex-wrap gap-2">
          <UButton
            leading-icon="mdi-cog"
            variant="soft"
            color="neutral"
            size="lg"
            @click="openModal()"
          >
            {{ t('dialog.cookie.manager') }}
          </UButton>

          <div class="grid grid-flow-col gap-2 lg:w-auto w-full">
            <UButton size="lg" @click="acceptOnlyNecessary()">
              {{ t('dialog.cookie.allowNecessary') }}
            </UButton>
            <UButton size="lg" @click="acceptAll()">
              {{ t('dialog.cookie.allowAll') }}
            </UButton>
          </div>
        </div>
      </UTheme>
    </template>
  </UDrawer>
</template>

<script setup lang="ts">
  import { useAppStorage } from '~/config/useConfigStorage'
  import { useCookieModal } from '~/stores/useCookieDialog'

  const { t } = useI18n()
  const { storageCkSetting } = useAppStorage()
  const { openModal } = useCookieModal()

  const showHint = ref(false)

  /** 接受所有cookie */
  function acceptAll() {
    storageCkSetting.value = {
      init: true,
      basic: true,
      analytics: true,
      preference: true,
    }
    showHint.value = false
  }

  /** 仅必要的cookie (相当于GDPR中的全部拒绝非必要) */
  function acceptOnlyNecessary() {
    storageCkSetting.value = {
      init: true,
      basic: true,
      analytics: false,
      preference: false,
    }
    showHint.value = false
  }

  onMounted(() => {
    showHint.value = !storageCkSetting.value.init
  })
</script>
